import { arrayOf, bool, func, number, shape, string } from 'prop-types'
import { connectHitsPerPage } from 'react-instantsearch-dom'

import HitsPerPageDesktop from './HitsPerPageDesktop'
import HitsPerPageMobile from './HitsPerPageMobile'

const DESKTOP_ID = 'select_limit'
const MOBILE_ID = 'select_limit_mobile'

const HitsPerPage = ({ mobile, ...rest }) => {
  const Component = mobile ? HitsPerPageMobile : HitsPerPageDesktop
  const props = {
    id: mobile ? MOBILE_ID : DESKTOP_ID,
    ...rest,
  }

  return <Component {...props} />
}

HitsPerPage.propTypes = {
  items: arrayOf(shape({})).isRequired,
  currentRefinement: number.isRequired,
  refine: func.isRequired,
  label: string.isRequired,
  mobile: bool,
}

HitsPerPage.defaultProps = {
  mobile: false,
}

export default connectHitsPerPage(HitsPerPage)
